import React from 'react';
import styles from './styles.module.scss';

interface LegendItemProps {
  color: string;
  text: string;
}

const LegendItem: React.FC<LegendItemProps> = ({ color, text }) => {
  return (
    <div className={styles.legend}>
      <span
        className={styles.color}
        style={{ backgroundColor: `var(--${color})` }}
      />
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default LegendItem;
